import { motion } from 'framer-motion';
import { SELFOS_BETA, SELFOS_DOWNLOAD_TRACKER } from '../lib/selfOsDownload';

export function SelfOsDownloadSection({ id = 'get-the-app' }: { id?: string }) {
  return (
    <section id={id} className="border-t border-essence-line bg-essence-surface/70">
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-24">
        <motion.div
          className="max-w-xl"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-40px' }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-essence-teal">
            Get the app
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-essence-ink sm:text-4xl">
            Self OS phone beta
          </h2>
          <p className="mt-4 text-base leading-relaxed text-essence-mute sm:text-lg">
            Earn Essence and Talk with Concierge on your Android phone.
          </p>

          <a
            href={SELFOS_DOWNLOAD_TRACKER}
            className="essence-cta mt-8 inline-flex items-center justify-center rounded-lg bg-essence-teal px-6 py-3.5 text-sm font-semibold text-white transition duration-200 hover:-translate-y-0.5 hover:bg-essence-teal-bright hover:shadow-[0_10px_24px_-12px_rgba(47,122,110,0.7)]"
          >
            Download Self OS beta (Android APK)
          </a>

          <p className="mt-4 text-sm text-essence-mute">Android 9+ · sideload required</p>
          <p className="mt-2 text-sm leading-relaxed text-essence-mute">
            Public beta — prototype; Essence is not cash; compute may use battery if you opt in.
          </p>

          <p className="mt-6 text-sm text-essence-mute">
            Support:{' '}
            <a
              href={`mailto:${SELFOS_BETA.supportEmail}`}
              className="font-medium text-essence-teal hover:text-essence-gold"
            >
              {SELFOS_BETA.supportEmail}
            </a>
          </p>
          <p className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm text-essence-mute">
            <a
              href="https://rolemodel.ai/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-essence-teal"
            >
              Privacy
            </a>
            <a
              href="https://rolemodel.ai/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-essence-teal"
            >
              Terms
            </a>
          </p>

          <details className="mt-8 border-t border-essence-line pt-4">
            <summary className="cursor-pointer text-sm font-medium text-essence-mute transition hover:text-essence-ink">
              Verify file
            </summary>
            <dl className="mt-3 space-y-3 text-sm">
              <div>
                <dt className="text-xs font-semibold uppercase tracking-wider text-essence-gold">Version</dt>
                <dd className="mt-1 text-essence-ink">{SELFOS_BETA.version}</dd>
              </div>
              <div>
                <dt className="text-xs font-semibold uppercase tracking-wider text-essence-gold">SHA-256</dt>
                <dd className="mt-1 break-all font-mono text-[11px] leading-relaxed text-essence-ink/90 sm:text-xs">
                  {SELFOS_BETA.sha256}
                </dd>
              </div>
            </dl>
          </details>
        </motion.div>
      </div>
    </section>
  );
}
